import React, { Component } from 'react';

class Study extends Component {
  render() {
    return (
    <div className='study'>
        <div className='study-main'>
            <h3>{this.props.title}</h3>
            <h4><a href={this.props.link} target="_blank" rel="noreferrer">{this.props.description}</a></h4>
            <div className='basic-text'>{this.props.info}</div>
        </div>
        <div className='study-sub'>
            <h5>{this.props.date}</h5>
            <h5>{this.props.location}</h5>
        </div>
    </div>
    );
  }
}

export default Study;